import {defineComponent, onMounted, watch} from 'vue';
import {useForm} from "vee-validate";
import {userLocalStorage} from "@/app/shared/helpers/user-local-storage.ts";
import * as yup from "yup";

const preferredPrepaidAmountLocalStorageKey: string = 'prepaid_preferred_amount';

export interface PrepaidAmount {
    amount: number;
}

const validationSchema = yup.object({
    amount: yup.string()
        .test('is_decimal', 'Voer een geldig bedrag in', (value) => {
            if (!value) return true;
            return /^([1-9]\d*)((([.,]\d*)?)$)/.test(value);
        })
        .test('max_nr_of_decimals', 'Op te laden bedrag mag maximaal 2 decimalen hebben', (value) => {
            if (!value) return true;
            return /^([1-9]\d*)(([.,]\d{0,2})?$)/.test(value);
        })
        .required('Op te laden bedrag is verplicht'),
});

export default defineComponent({
    name: 'AegTopUpAmount',
    props: {
        amount: {
            type: Number,
            default: 100,
        },
    },
    emits: ['update:amount', 'validated'],
    setup(props, { emit }) {
        const {defineField, meta, values, setValues, errors} = useForm<PrepaidAmount>({
            validationSchema: validationSchema,
            validateOnMount: false,
        });

        const [amount,amountProps] = defineField('amount');

        const amountChanged = (newAmount: PrepaidAmount) => {
            if(newAmount && newAmount.amount){
                userLocalStorage.setItem<number>(preferredPrepaidAmountLocalStorageKey, newAmount.amount);    
            }
            emit('update:amount', newAmount?.amount);
        }

        watch(() => ({ ...values }), amountChanged, { deep: true });
        watch(() => meta.value.valid, () => {emit('validated', meta.value.valid)}, { deep: true });
        
        onMounted(() => {
            const preferredPrepaidAmount = userLocalStorage.getItem<number>(preferredPrepaidAmountLocalStorageKey);
            const amount = preferredPrepaidAmount ? preferredPrepaidAmount : props.amount;
            setValues({ amount });
        });

        
        return {
            errors,
            amount,
            amountProps,
            amountChanged,
        }
    }
})
